import React from 'react'

import { Element } from './index.styled'

const Button = ({
  children,
  className,
  bkey = '',
  textOpen = '',
  ...props
}) => {
  return (
    <Element
      $bkey={bkey}
      {...props}
      className={[className, textOpen ? 'openState' : ''].join(' ')}
    >
      <span>{children}</span>
      <span className='textOpen'>{textOpen}</span>
    </Element>
  )
}

export default Button
